import {NEW_PROPOSAL as ActionTypes} from '../actionTypes';
import * as newProposalApi from "../../services/newProposalApi";
import * as elevatorCompanyApi from "../../services/elevatorCompanyApi";

export function setNewProposal(payload) {
    return async (dispatch) => {
        const currentYear = payload.proposal.year ? payload.proposal.year : new Date().getFullYear();

        payload.lines = Object.values(
            payload.lines?.reduce((acc, item) => {
                const buildingId = item.buildingId;

                if (!acc[buildingId]) {
                    acc[buildingId] = {
                        ...item,
                        devices: [],
                        isPeriodic: false,
                        _deviceMap: new Map()
                    };
                }

                const building = acc[buildingId];

                if (item.device) {
                    const deviceIsPeriodic = item.isPeriodic;

                    if (building._deviceMap.has(item.device)) {
                        const existingDevice = building._deviceMap.get(item.device);
                        existingDevice.isPeriodic = existingDevice.isPeriodic || deviceIsPeriodic;
                    } else {
                        const newDevice = {
                            ...item,
                            isPeriodic: deviceIsPeriodic,
                            buildingId: buildingId,
                        };

                        building.devices.push(newDevice);
                        building._deviceMap.set(item.device, newDevice);
                    }

                    building.isPeriodic = building.isPeriodic || deviceIsPeriodic;
                }

                return acc;
            }, {})
        ).map(building => {
            const {_deviceMap, ...rest} = building;

            return rest;
        });

        payload.expiringLines = payload.lines.filter(f => f.agreementThroughYear <= currentYear);
        payload.underContractLines = payload.lines.filter(f => f.agreementThroughYear > currentYear);

        dispatch(
            {
                type: ActionTypes.SET_NEW_PROPOSAL,
                payload: payload
            }
        )
        return payload;
    }
}

export function setProposalV2(payload) {

    return async (dispatch) => {
        const currentYear = payload.proposal.year ? payload.proposal.year : 2024;

        payload.expiringLines = payload.lines?.filter(f => f.agreementThroughYear == currentYear);
        payload.underContractLines = payload.lines?.filter(f => f.agreementThroughYear >= currentYear + 1);

        dispatch(
            {
                type: ActionTypes.SET_PROPOSAL_V2,
                payload: payload
            }
        )
        
        return payload;
    }
}
export function setNewProposalDetail(payload) {
    return async (dispatch) => {
        dispatch(
            {
                type: ActionTypes.SET_NEW_PROPOSAL_DETAIL,
                payload: payload
            }
        )
    }
}

export function updateBuilding(payload) {
    return async (dispatch) => {
        dispatch(
            {
                type: ActionTypes.UPDATE_BUILDING,
                payload: payload
            }
        )
    }
}

export function updateDeviceElevatorCompany(payload) {
    return async (dispatch) => {
        dispatch(
            {
                type: ActionTypes.UPDATE_DEVICE_ELEVATOR_COMPANY,
                payload
            }
        )
    }
}

export function updateNewAllLines(payload) {
    return async (dispatch) => {
        dispatch(
            {
                type: ActionTypes.SET_NEW_LINES,
                payload: payload
            }
        )
    }
}

export function updateOptionalServices(payload) {
    return async (dispatch) => {
        try {
            await newProposalApi.updateOptionalServices(payload);

            dispatch({
                type: ActionTypes.UPDATE_OPTIONAL_SERVICES,
                payload,
            });
        } catch (error) {
            throw error;
        }
    };
}


export function setElevatorCompanies() {
    return async (dispatch) => {
        try {
            const elevatorCompanies = await elevatorCompanyApi.getAll();

            const elevatorCompaniesOptions = elevatorCompanies?.data?.map((e) => ({
                value: e.elevatorCompanyId,
                label: e.elevatorCompanyName
            }));

            dispatch({
                type: ActionTypes.SET_ELEVATOR_COMPANIES,
                payload: elevatorCompaniesOptions,
            });
        } catch (error) {
            throw error;
        }
    };
}